export default __webpack_public_path__ + "static/media/IMG_0301.62089469.jpg";